import CryptoJS from 'crypto-js'

const SECRET_KEY = 'YOUR_SECRET_KEY' // ⚠️ 建議改成環境變數

export const encryptionService = {
  encryptData(data: unknown): string {
    try {
      const json = JSON.stringify(data)
      const encrypted = CryptoJS.AES.encrypt(json, SECRET_KEY).toString()
      return btoa(encrypted)
    } catch (error) {
      console.error('加密失敗:', error)
      throw error
    }
  },

  decryptData<T = any>(encodedData: string): T {
    try {
      const decryptedBase64 = atob(encodedData)
      const bytes = CryptoJS.AES.decrypt(decryptedBase64, SECRET_KEY)
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8)
      return JSON.parse(decryptedText) as T
    } catch (error) {
      console.error('解密失敗:', error)
      throw error
    }
  },
}
